import { AssetSensorsHealthStatus } from '@/types/models/assets.types';
import { HEALTH_STATUS, SENSOR_STATUS } from '@/const';

const cutoffDate = new Date('2017-01-01T00:00:00.000Z');

export const isNotMonitored = (asset: any, siteLastVerified: any) => {
  return (
    siteLastVerified &&
    (new Date(asset.latest_diagnostic_created_at) < new Date(siteLastVerified) ||
      new Date(siteLastVerified) < cutoffDate)
  );
};

export enum SENSORS_OVERALL_STATUS {
  Healthy = 'healthy',
  Critical = 'critical',
  Warning = 'warning',
}

export const getSensorsOverallStatusUpdated = (sensors: AssetSensorsHealthStatus[]) => {
  const offlineSensors = [];
  const onlineSensors = [];

  if (sensors) {
    for (const sensor of sensors) {
      if (sensor.health_status === SENSOR_STATUS.OFFLINE || sensor.health_status === SENSOR_STATUS.DATA_NOT_RECEIVED) {
        offlineSensors.push(sensor);
      }
      if (sensor.health_status === SENSOR_STATUS.ONLINE || sensor.health_status === SENSOR_STATUS.DATA_RECEIVED) {
        onlineSensors.push(sensor);
      }
    }
  }

  if (offlineSensors.length === 0 && onlineSensors.length > 0) {
    return SENSORS_OVERALL_STATUS.Healthy;
  }

  if (offlineSensors.length >= 1 && onlineSensors.length > 0) {
    return SENSORS_OVERALL_STATUS.Warning;
  }

  return SENSORS_OVERALL_STATUS.Critical;
};

export const sortSensors = (sensors: AssetSensorsHealthStatus[]) => {
  return sensors
    ? [...sensors].sort((a, b) => {
        if (a.last_uptime > b.last_uptime) return -1;
        if (a.last_uptime < b.last_uptime) return 1;
        if (a.sensor_name < b.sensor_name) return -1;
        if (a.sensor_name > b.sensor_name) return 1;
        return 0;
      })
    : [];
};